// import {env} from "process";

export const CURRENT_CONFIG = {

  // license
  appId: '166162', // You need to go to the development website to apply.
  appKey: 'e5f579050757cc84eb7afed5db1f4bb', // You need to go to the development website to apply.
  appLicense: 'DIj9yyDP37xUxHYVrTMBXIUfd60VkH4PmhppxSpGFQCtJd9mXDZBJQAD9I3HJR/DmGODTqnkAvxoXTJL4zGAuhp+rM5tUUC+FVJWFEbCXIMvU9MZ+lr47+m0ruJDVsKZHokB8GjWfVuf3hERmVVbrIojRkAzUM43Cjs55Fu8rRE=', // You need to go to the development website to apply.

  // http
  baseURL: import.meta.env.VITE_APP_APIGATEWAY_BACKEND_HOST,
  websocketURL: import.meta.env.VITE_APP_WEBSOCKET_BACKEND_HOST,
  // baseURL: 'http://127.0.0.1:6789', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  // websocketURL: 'http://127.0.0.1:6789/api/v1/ws', // Example: 'ws://192.168.1.1:6789/api/v1/ws'
  // baseURL: 'http://192.168.3.16:6789', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  // websocketURL: 'http://192.168.3.16:6789/api/v1/ws', // Example: 'ws://192.168.1.1:6789/api/v1/ws'

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'rtmp://push-fly-test.zcwalk.com/cloud/demo1', // Example: 'rtmp://192.168.1.1/live/'

  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',

  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',

  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  amapKey: '24f8ad037160dd62e050df6ef7fac76a',

}
